import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Header from "../components/Header";

const amazonCategoryLinks = {
  accessories: "https://www.amazon.in/s?k=accessories&tag=digitalspires-21",
  mobiles: "https://www.amazon.in/s?k=mobiles&tag=digitalspires-21",
  beauty: "https://www.amazon.in/s?k=beauty&tag=digitalspires-21",
  flight: "https://www.amazon.in/s?k=flight+tickets&tag=digitalspires-21",
  grocery: "https://www.amazon.in/s?k=grocery&tag=digitalspires-21",
  pharma: "https://www.amazon.in/s?k=medicine&tag=digitalspires-21",
  education: "https://www.amazon.in/s?k=books&tag=digitalspires-21",
  loan: "https://www.amazon.in/s?k=loan&tag=digitalspires-21",
};

const Home = () => {
  const navigate = useNavigate();
  const categoriesStartRef = useRef(null);

  const [categories, setCategories] = useState([]);
  const [stores, setStores] = useState([]);
  const [coupons, setCoupons] = useState([]);
  const [offers, setOffers] = useState([]);

  const [wallet, setWallet] = useState({
    total_confirmed: 0,
    total_pending: 0,
  });

  useEffect(() => {
    axios.get("https://cashpaobackend.salepatner.com/api/categories/").then((res) => setCategories(res.data));
    axios.get("https://cashpaobackend.salepatner.com/api/stores/").then((res) => setStores(res.data));
    axios.get("https://cashpaobackend.salepatner.com/api/coupons/").then((res) => setCoupons(res.data));
    axios.get("https://cashpaobackend.salepatner.com/api/offers/").then((res) => setOffers(res.data));

    const rawToken =
  localStorage.getItem("token") ||            // most common
  localStorage.getItem("access") ||
  localStorage.getItem("access_token") ||
  localStorage.getItem("jwt");

console.log("🔑 Token Found:", rawToken);

if (!rawToken) {
  console.warn("⚠ No token found — skipping wallet API");
} else {
  axios
    .get("https://cashpaobackend.salepatner.com/api/user/wallet/", {
      headers: { Authorization: `Bearer ${rawToken}` },
    })
    .then((res) => setWallet(res.data))
    .catch((err) => {
      console.error("Wallet API Error:", err.response?.status, err.response?.data);
    });
}

  }, []);

  return (
    <div className="min-h-screen bg-gray-50 font-sans">
      <Header wallet={wallet} />

      {/* 🔥 Amazon Products Section */}
      <section className="w-full bg-white py-10 px-6">
        <h2 className="text-3xl font-extrabold text-gray-900 text-center mb-10">
          Amazon Best Sellers Today
        </h2>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-6">
          {[
  {
    id: "p1",
    title: "Wireless Earbuds",
    image: "https://pisces.bbystatic.com/image2/BestBuy_US/images/products/6532/6532920_sd.jpg",
    price: 899,
    commission: 0.08,
    tag: "earbuds",
  },
  {
    id: "p2",
    title: "Smartwatch",
    image: "https://tse2.mm.bing.net/th/id/OIP.xWzUTQRfefHpT3DtGlaQVwHaHa?cb=ucfimg2&pid=ImgDet&ucfimg=1&w=178&h=178&c=7&dpr=1.5&o=7&rm=3",
    price: 1299,
    commission: 0.1,
    tag: "smartwatch",
  },
  {
    id: "p3",
    title: "Men's Trimmer",
    image: "https://th.bing.com/th/id/OIP.gS3WmAo7xP3_oSXvWoXL5AHaIf?w=171&h=195&c=7&r=0&o=7&cb=ucfimg2&dpr=1.5&pid=1.7&rm=3&ucfimg=1",
    price: 699,
    commission: 0.09,
    tag: "trimmer",
  },
  {
    id: "p4",
    title: "Fast Charging Power Bank",
    image: "https://th.bing.com/th/id/OPAC.dl968f2b6ChBnA474C474?w=220&h=220&c=17&o=5&dpr=1.5&pid=21.1&ucfimg=1",
    price: 999,
    commission: 0.06,
    tag: "powerbank",
  },
  {
    id: "p5",
    title: "Bluetooth Speaker",
    image: "https://uk.jbl.com/on/demandware.static/-/Library-Sites-SharedLibrary-JB/default/dwb95d3777/glp/waterproof-ccpi/images/flip5-visual.jpg",
    price: 799,
    commission: 0.08,
    tag: "speaker",
  },
]
.map((item) => {
            const commissionEarned = item.price * item.commission;
            const userCashback = Math.round(commissionEarned * 0.7);
            const yourEarning = Math.round(commissionEarned * 0.3);

            const clickId = Math.random().toString(36).substring(2, 10);
            const amazonLink = `https://www.amazon.in/?tag=digitalspires-21&ascsubtag=${item.tag}-${clickId}`;

            return (
              <div
                key={item.id}
                onClick={() => window.open(amazonLink, "_blank")}
                className="cursor-pointer bg-white border rounded-xl shadow hover:shadow-xl transition p-4 relative"
              >
                {/* 🔴 LIVE SALE BADGE */}
                <div className="absolute top-2 left-2 bg-red-600 text-white text-[8px] font-bold px-2 py-1 rounded-full shadow">
                  🔴 LIVE SALE • Trending Now
                </div>
                <br></br>

                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-40 object-contain rounded"
                />

                <h3 className="mt-3 text-sm font-semibold text-gray-800">
                  {item.title}
                </h3>

                <p className="text-green-600 font-bold mt-1">₹{item.price}</p>

                <div className="mt-3 bg-green-50 border border-green-300 rounded-lg p-2 text-center">
                  <p className="text-green-700 font-bold text-sm">
                    Earn Cashback
                  </p>
                 
                </div>

                <button className="mt-3 w-full bg-yellow-500 text-black py-1.5 rounded font-semibold text-sm">
                  Shop on Amazon →
                </button>
              </div>
            );
          })}
        </div>
      </section>

      {/* -------------------- TOP CATEGORIES -------------------- */}
      <section className="w-full bg-white py-12 border-t border-gray-100">
        <div className="mx-auto px-6">
          <h2 className="text-3xl font-extrabold text-gray-900 text-center mb-2">
            Earn More, Save More — Top Categories for You
          </h2>
          <p className="text-gray-500 text-center mb-10 text-lg">
            Explore brands that give you the best cashback and rewards
          </p>

          <div
            id="catScroll"
            ref={categoriesStartRef}
            className="flex space-x-8 overflow-x-auto scrollbar-hide scroll-smooth px-6 py-2"
          >
            {categories.map((cat) => (
              <div
                key={cat.id}
                onClick={() => {
  const slug = cat.name.toLowerCase();
  const baseUrl = amazonCategoryLinks[slug];

  const clickId = Math.random().toString(36).substring(2, 10);

  if (baseUrl) {
    const finalUrl = `${baseUrl}&ascsubtag=${slug}-${clickId}`;
    window.open(finalUrl, "_blank");
  } else {
    console.log("Amazon category link not found for:", slug);
  }
}}

                className="flex flex-col items-center min-w-[120px] cursor-pointer"
              >
                <div className="w-28 h-28 rounded-full bg-gray-50 shadow-sm flex items-center justify-center border">
                  <img
                    src={cat.icon}
                    alt={cat.name}
                    className="w-16 h-16 object-contain rounded-full"
                  />
                </div>
                <p className="text-base font-semibold text-gray-700 mt-3 text-center">
                  {cat.name}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/*
       -------------------- TRENDING DEALS -------------------- 
      <section className="mx-auto px-6 mt-16">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-extrabold text-gray-900 mb-2">🌟 Trending Deals</h2>
          <p className="text-gray-500 text-lg">
            Discover top offers and trending deals handpicked for you
          </p>
          <a href="/offers" className="text-indigo-600 font-semibold hover:underline">
            View All →
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {offers.slice(0, 4).map((offer) => (
            <div
              key={offer.id}
              className="bg-gradient-to-br from-pink-50 to-indigo-50 border rounded-2xl p-6 shadow-sm"
            >
              <div className="w-full h-40 rounded-xl overflow-hidden shadow-md">
                <img src={offer.image} alt={offer.title} className="w-full h-full object-cover" />
              </div>

              <h3 className="text-center text-lg font-bold text-gray-800 mt-4">
                {offer.title}
              </h3>

              <p className="text-center text-gray-500 text-sm mt-2">{offer.description}</p>

              <div className="flex justify-center mt-5">
                <a
                  href={offer.link}
                  target="_blank"
                  rel="noreferrer"
                  className="bg-gradient-to-r from-indigo-600 to-pink-500 text-white text-sm px-6 py-2 rounded-full shadow"
                >
                  Shop Now →
                </a>
              </div>
            </div>
          ))}
        </div>
      </section>

      */}

      {/* -------------------- POPULAR STORES -------------------- */}
      <section className="w-full bg-white py-14">
        <div className="mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-extrabold text-gray-900 mb-3">🏬 Popular Stores</h2>
            <p className="text-gray-500 text-lg mb-4">
              Explore India’s most trusted shopping destinations
            </p>
            <div className="mx-auto w-24 h-1 bg-green-500"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
            <div className="bg-white border rounded-xl shadow-sm p-6 flex flex-col justify-between">
              <h3 className="text-sm font-semibold text-gray-600 mb-4">
                Featured Store Of The Month
              </h3>

              <div className="flex justify-center items-center mb-6">
                <img
                  src={stores.length > 0 ? stores[0].logo : "https://via.placeholder.com/120x80"}
                  alt="Store"
                  className="w-32 h-20 object-contain"
                />
              </div>

              <p className="text-sm text-center text-gray-700 border-t pt-4">
                0 Coupons | <span className="text-green-600 font-semibold">41 Offers Available</span>
              </p>
            </div>

            <div className="md:col-span-4 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6">
              {stores.slice(0, 12).map((store) => (
                <Link
                  key={store.id}
                  to={`/stores/${store.slug}`}
                  className="border rounded-xl shadow-sm p-4 bg-white flex justify-center"
                >
                  <img src={store.logo} alt={store.name} className="max-h-10" />
                </Link>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* -------------------- COUPONS -------------------- */}
      <section className="mx-auto px-6 mt-16">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-extrabold text-gray-900">🎟️ Best Coupons</h2>
          <p className="text-gray-500 text-lg mt-1">
            Unlock exclusive discounts and cashback on top brands
          </p>
          <div className="mx-auto w-24 h-1 bg-indigo-500 mt-4"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-6">
          {coupons &&
            coupons.slice(0, 3).map((coupon) => (
              <div
                key={coupon.id}
                className="bg-gradient-to-br from-indigo-50 to-pink-50 p-6 rounded-xl border shadow-md"
              >
                <h3 className="text-lg font-semibold text-gray-800 mb-2">
                  {coupon.title}
                </h3>
                <p className="text-sm text-gray-600 mb-4">{coupon.description}</p>

                <div className="flex justify-between items-center">
                  <span className="font-mono text-indigo-600 bg-indigo-100 px-3 py-1 rounded">
                    {coupon.code || "SAVE100"}
                  </span>
                  <button
                    className="bg-indigo-600 text-white px-4 py-1 rounded"
                    onClick={() => navigator.clipboard.writeText(coupon.code)}
                  >
                    Copy
                  </button>
                </div>
              </div>
            ))}
        </div>
      </section>

      {/* -------------------- FOOTER -------------------- */}
      <footer className="bg-gray-900 text-gray-300 mt-20 py-12">
        <div className="max-w-7xl mx-auto px-6 grid grid-cols-2 sm:grid-cols-4 gap-8">
          <div>
            <h3 className="font-semibold text-white mb-3">About</h3>
            <ul className="space-y-2 text-sm">
              <li><a href="#" className="hover:text-white">About DigiKaro</a></li>
              <li><a href="#" className="hover:text-white">How It Works</a></li>
              <li><a href="#" className="hover:text-white">Press & Media</a></li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-white mb-3">Help</h3>
            <ul className="space-y-2 text-sm">
              <li><a href="#" className="hover:text-white">FAQs</a></li>
              <li><a href="#" className="hover:text-white">Support</a></li>
              <li><a href="#" className="hover:text-white">Contact Us</a></li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-white mb-3">Legal</h3>
            <ul className="space-y-2 text-sm">
              <li><a href="#" className="hover:text-white">Terms & Conditions</a></li>
              <li><a href="#" className="hover:text-white">Privacy Policy</a></li>
              <li><a href="#" className="hover:text-white">Disclaimer</a></li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-white mb-3">Follow Us</h3>
            <div className="flex space-x-4">
              <a href="#" className="hover:text-white text-xl">🌐</a>
              <a href="#" className="hover:text-white text-xl">📘</a>
              <a href="#" className="hover:text-white text-xl">📸</a>
            </div>
          </div>
        </div>

        <div className="text-center text-sm text-gray-500 mt-10 border-t border-gray-700 pt-6">
          © {new Date().getFullYear()} CashPao — All rights reserved.
        </div>
      </footer>
    </div>
  );
};

export default Home;
